export default __webpack_public_path__ + "static/media/inputVerifyLogo.041ca894.svg";